module.exports = __webpack_public_path__ + "klimtsonian.jpg?96acb169ba2af01d3d7c8f3b509c1e42";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/klimtsonian.jpg
// module id = 668
// module chunks = 0